// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-loader {
  background: linear-gradient(120deg, #c2faff, #fcfcfc);
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 9;
}
.page-loader.hideLoader {
  display: none;
}
.page-loader .content {
  position: absolute;
  top: 50%;
  left: 50%;
}
.page-loader .content .loader-line {
  width: 16rem;
  height: 3px;
  overflow: hidden;
  background-color: #ddd;
  border-radius: 20px;
  position: absolute;
  top: 4rem;
  left: -8rem;
}
.page-loader .content .loader-line:before {
  content: "";
  position: absolute;
  left: -50%;
  height: 3px;
  width: 40%;
  background-color: var(--color-maersk-blue);
  animation: lineAnim 1s linear infinite;
  border-radius: 20px;
}
.page-loader .content h2 {
  color: var(--color-white);
  font-size: 8em;
  position: absolute;
  transform: translate(-50%, -50%);
}
.page-loader .content h2:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 2px var(--color-maersk-darkblue);
}
.page-loader .content h2:nth-child(2) {
  color: #83e0ff;
  animation: animate 4s ease-in-out infinite;
}

@keyframes animate {
  0%, 100% {
    clip-path: polygon(0% 45%, 16% 44%, 33% 50%, 54% 60%, 70% 61%, 84% 59%, 100% 52%, 100% 100%, 0% 100%);
  }
  50% {
    clip-path: polygon(0% 60%, 15% 65%, 34% 66%, 51% 62%, 67% 50%, 84% 45%, 100% 46%, 100% 100%, 0% 100%);
  }
}
@keyframes lineAnim {
  0% {
    left: -40%;
  }
  50% {
    left: 20%;
    width: 80%;
  }
  100% {
    left: 100%;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/PageLoader/PageLoader.scss"],"names":[],"mappings":"AAAA;EACE,qDAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AACF;AAAE;EACE,aAAA;AAEJ;AAAE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AAEJ;AADI;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAGN;AAAI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,0CAAA;EAGA,sCAAA;EAGA,mBAAA;AAEN;AAAI;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;AAEN;AAAI;EACE,kBAAA;EACA,qDAAA;AAEN;AAAI;EACE,cAAA;EACA,0CAAA;AAEN;;AAEA;EACE;IAEE,qGAAA;EAAF;EAaA;IACE,qGAAA;EAXF;AACF;AAwBA;EACE;IACE,UAAA;EAtBF;EAwBA;IACE,SAAA;IACA,UAAA;EAtBF;EAwBA;IACE,UAAA;IACA,WAAA;EAtBF;AACF","sourcesContent":[".page-loader {\n  background: linear-gradient(120deg, #c2faff, #fcfcfc);\n  position: absolute;\n  width: 100%;\n  top: 0px;\n  left: 0px;\n  bottom: 0px;\n  right: 0px;\n  z-index: 9;\n  &.hideLoader {\n    display: none;\n  }\n  .content {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    .loader-line {\n      width: 16rem;\n      height: 3px;\n      overflow: hidden;\n      background-color: #ddd;\n      border-radius: 20px;\n      position: absolute;\n      top: 4rem;\n      left: -8rem;\n    }\n\n    .loader-line:before {\n      content: \"\";\n      position: absolute;\n      left: -50%;\n      height: 3px;\n      width: 40%;\n      background-color: var(--color-maersk-blue);\n      -webkit-animation: lineAnim 1s linear infinite;\n      -moz-animation: lineAnim 1s linear infinite;\n      animation: lineAnim 1s linear infinite;\n      -webkit-border-radius: 20px;\n      -moz-border-radius: 20px;\n      border-radius: 20px;\n    }\n    h2 {\n      color: var(--color-white);\n      font-size: 8em;\n      position: absolute;\n      transform: translate(-50%, -50%);\n    }\n    h2:nth-child(1) {\n      color: transparent;\n      -webkit-text-stroke: 2px var(--color-maersk-darkblue);\n    }\n    h2:nth-child(2) {\n      color: #83e0ff;\n      animation: animate 4s ease-in-out infinite;\n    }\n  }\n}\n@keyframes animate {\n  0%,\n  100% {\n    clip-path: polygon(\n      0% 45%,\n      16% 44%,\n      33% 50%,\n      54% 60%,\n      70% 61%,\n      84% 59%,\n      100% 52%,\n      100% 100%,\n      0% 100%\n    );\n  }\n\n  50% {\n    clip-path: polygon(\n      0% 60%,\n      15% 65%,\n      34% 66%,\n      51% 62%,\n      67% 50%,\n      84% 45%,\n      100% 46%,\n      100% 100%,\n      0% 100%\n    );\n  }\n}\n\n@keyframes lineAnim {\n  0% {\n    left: -40%;\n  }\n  50% {\n    left: 20%;\n    width: 80%;\n  }\n  100% {\n    left: 100%;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
